/**
 *  @class
 *  @function ImageTextOverlay
 */

if (!customElements.get('image-with-text-overlay')) {
  class ImageTextOverlay extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
      this.parallaxTween = false;
    }
    connectedCallback() {
      if (typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined' && typeof window.SplitText !== 'undefined') {
        if (this.isAboveFold()) {
          this.showStaticContent();
          this.prepareParallax();
          return;
        }

        this.applyInitialState();
        this.prepareAnimations();
        return;
      }

      this.showStaticContent();
    }
    disconnectedCallback() {
      if (this.tl && typeof this.tl.kill === 'function') {
        this.tl.kill();
      }
      if (this.parallaxTween && typeof this.parallaxTween.kill === 'function') {
        this.parallaxTween.kill();
      }
      if (this.splittext && typeof this.splittext.revert === 'function') {
        this.splittext.revert();
      }
    }
    isAboveFold() {
      let rect = this.getBoundingClientRect();

      return rect.top < window.innerHeight && rect.bottom > 0;
    }
    applyInitialState() {
      this.querySelectorAll('.inline-badge, .subheading, .button').forEach((el) => {
        el.style.opacity = '0';
      });

      this.querySelectorAll('.image-with-text-overlay--heading, .rte p').forEach((el) => {
        el.style.visibility = 'hidden';
      });
    }
    showStaticContent() {
      this.querySelectorAll('.inline-badge, .subheading, .button, .image-with-text-overlay--heading, .rte p').forEach((el) => {
        el.style.opacity = '1';
        el.style.visibility = 'visible';
        el.style.transform = 'none';
      });
    }
    prepareParallax() {
      let section = this,
        property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      if (section.parallaxTween || !section.querySelector('.thb-parallax-image')) {
        return;
      }

      section.parallaxTween = gsap.fromTo(section.querySelectorAll('.thb-parallax-image'), {
        y: '-8%'
      }, {
        y: '8%',
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          scrub: 1,
          start: () => `top bottom`,
          end: () => `bottom top+=${property}`,
          onUpdate: () => {
            property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';
          }
        }
      });
    }
    prepareAnimations() {
      let section = this,
        button_offset = 0;

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      let fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();

      fontsReady.then(function () {
        section.splittext = new SplitText(section.querySelectorAll('.image-with-text-overlay--heading, p:not(.subheading)'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        if (section.querySelector('.inline-badge')) {
          section.tl
            .fromTo(section.querySelector('.inline-badge'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 1
            }, 0);

          button_offset += 0.5;
        }
        if (section.querySelector('.subheading')) {
          section.tl
            .fromTo(section.querySelector('.subheading'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 0.6
            }, 0);

          button_offset += 0.5;
        }
        if (section.querySelector('.image-with-text-overlay--heading')) {
          let h3_duration = 0.8 + ((section.querySelectorAll('.image-with-text-overlay--heading .line-child div').length - 1) * 0.08);
          section.tl
            .set(section.querySelector('.image-with-text-overlay--heading'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('.image-with-text-overlay--heading .line-child div'), {
              duration: h3_duration,
              yPercent: '100',
              stagger: 0.08
            }, 0);
          button_offset += h3_duration;
        }
        if (section.querySelector('.rte p')) {
          let p_duration = 0.8 + ((section.querySelectorAll('.rte p .line-child div').length - 1) * 0.02);
          section.tl
            .set(section.querySelectorAll('.rte p'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('.rte p .line-child div'), {
              duration: p_duration,
              yPercent: '100',
              stagger: 0.02
            }, 0);
          button_offset += p_duration;
        }
        if (section.querySelectorAll('.button')) {
          let i = 1;
          section.querySelectorAll('.button').forEach((item) => {
            section.tl.fromTo(item, {
              autoAlpha: 0
            }, {
              duration: 0.5,
              autoAlpha: 1
            }, ((button_offset * 0.4) + (i - 1) * 0.1));
            i++;
          });
        }

      });

      section.prepareParallax();
    }
  }
  customElements.define('image-with-text-overlay', ImageTextOverlay);
}
